/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Reset_Password_Too_LongInputs */

const cs_auth_reset_password_too_long = /** @type {(inputs: Auth_Reset_Password_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heslo je příliš dlouhé.`)
};

const en_auth_reset_password_too_long = /** @type {(inputs: Auth_Reset_Password_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password is too long.`)
};

/**
* | output |
* | --- |
* | "Password is too long." |
*
* @param {Auth_Reset_Password_Too_LongInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_reset_password_too_long = /** @type {((inputs?: Auth_Reset_Password_Too_LongInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Reset_Password_Too_LongInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_reset_password_too_long(inputs)
	return cs_auth_reset_password_too_long(inputs)
});